export default __webpack_public_path__ + "static/media/TodayNext.49e0ddca.png";